module.exports = __webpack_public_path__ + "img/02047eafcefd8fa4b9c19f6fef85cfe3.png";